import script from "./OTPForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OTPForm.vue?vue&type=script&setup=true&lang=ts"

import "./OTPForm.vue?vue&type=style&index=0&id=57995840&lang=css"

const __exports__ = script;

export default __exports__